import { media } from '@simplywallst/ui-core';
import styled, { css } from 'styled-components';
import type { StatementValue } from './Statement';

const color = css<{ value?: StatementValue }>`
  ${({ value, theme }) => {
    if (value === true || value === 'Pass') {
      return theme.color.good;
    }
    return theme.color.bad;
  }};
`;

export const StatementAnchor = styled('div')`
  position: absolute;
  top: -${({ theme }) => theme.x19spacePx}px;
  ${media.mdDown`
    top: -${({ theme }) => theme.x12spacePx}px;
  `};
`;

export const StatementWrapper = styled('blockquote')<{
  value?: StatementValue;
  noIcon?: boolean;
  size: 'small' | 'default';
}>`
  position: relative;
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  text-align: left;
  > svg {
    position: absolute;
    top: ${({ size }) => (size === 'small' ? -2 : 2)}px;
    left: 0;
    width: ${({ theme }) => theme.x3spacePx}px;
    height: ${({ theme }) => theme.x3spacePx}px;
    fill: ${color};
  }
  > p {
    ${({ theme, size }) =>
      size === 'small' ? theme.typography.xSmall : theme.typography.small}
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
    padding-left: ${({ theme, noIcon }) => (noIcon ? 0 : theme.x4spacePx)}px;
  }
`;

export const StatementTitle = styled('span')<{ value?: StatementValue }>`
  color: ${color};
`;

export const Term = styled('span')`
  white-space: nowrap;
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: help;
  background-color: ${({ theme }) => theme.color.brand01RGBA(0.1)};
`;

export const TooltipTitle = styled('p')`
  margin: 0;
  max-width: 200px;
  color: ${({ theme }) => theme.color.spaceGray};
`;
